import { extractBodyFromContent } from "@/components/document-chat/utils";
import type { KarlCustomPayload } from "@/components/document-chat/services/streamEventTypes";
import { ChatStatus, StreamPhase } from "@/constants/enums";
// Types are globally available from @/types/chat-sse.d.ts
import type { DocumentChatRuntime } from "../types";

/**
 * Handles DATA events, specifically FinalizeAnswer processing
 *
 * @param payload - The data event payload
 * @param session - The current stream session
 * @param runtime - The document chat runtime store interface
 * @param cancel - Function to cancel the stream
 * @param extractAndSetSources - Function to extract sources from metadata
 */
export function handleDataEvent(
  payload: KarlCustomPayload,
  session: StreamSession,
  runtime: DocumentChatRuntime,
  cancel: () => void,
  extractAndSetSources: (_contentObj: unknown) => void
): void {
  const nodeName = String(payload.node ?? "");

  if (/finalizeanswer/i.test(nodeName)) {
    // Only use the complete answer as fallback if we haven't streamed anything yet
    if (!session.answerHasStreamed) {
      runtime.markAnswerStart();
      const body = extractBodyFromContent(payload.content);

      if (body) {
        // Use the finalized body as the entire response (no token-by-token appends)
        runtime.update({ phase: StreamPhase.ANSWERING, streamingContent: body });
      } else {
        runtime.update({ phase: StreamPhase.ANSWERING });
      }
      session.answerHasStreamed = true;
    }

    // Always extract sources from metadata if present
    extractAndSetSources(payload.content);

    // Auto-disconnect after final answer
    try {
      cancel();
    } catch (_e) {
      /* noop */
    }
    runtime.update({ status: ChatStatus.CLOSED, phase: StreamPhase.DONE });
  }
}
